<div class="bread-crumb-container">
  <h2 class="margin-0">Maintenance</h2>
</div>
<div class="global-container" [ngStyle]="{'overflow':'auto'}">
  <div class="container-fluid">
    <cdk-accordion class="container-fluid" multi = "true" [ngStyle]="{'margin-top':'20px'}">
        <cdk-accordion-item
          #accordionItemOne="cdkAccordionItem"
          class="example-accordion-item acc-separator"
          role="button"
          tabindex="0"
          [attr.id]="'accordion-header-' + 1"
          [attr.aria-expanded]="accordionItemOne.expanded"
          [attr.aria-controls]="'accordion-body-' + 1">
          <div class="example-accordion-item-header acc-header-btm-brdr acc-header-lft-brder" (click)="accordionItemOne.toggle()">
            <h3 class="margin-0">Email Settings</h3>
            <span class="example-accordion-item-description">
              <mat-icon class="cmmn-icn-color" (click) = "resetDefaultVal()">{{ accordionItemOne.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
            </span>
          </div>
          <div
            class="example-accordion-item-body"
            role="region"
            [style.display]="accordionItemOne.expanded ? '' : 'none'"
            [attr.id]="'accordion-body-' + 1"
            [attr.aria-labelledby]="'accordion-header-' + 1">
              <form [formGroup]= 'emailSettingsValues'>
                <div class="d-flex row pd-r-23">
                    <div class = "col-md-6">
                      <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                          <mat-label class="body-font-size">Send reminder XX minutes before scheduled start time</mat-label>
                          <input matInput type="text" formControlName = 'MEETING_REM_DURATION' maxlength = '3' (keypress)="numberOnly($event)">
                          <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                      </mat-form-field>
                    </div>
                    <div class = "col-md-6">
                      <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                          <mat-label class="body-font-size">Automatically approve minutes after XX hours of draft minutes (0 to approve manually)</mat-label>
                          <input matInput type="text" formControlName = 'APPROVE_DURATION' maxlength = '3' (keypress)="numberOnly($event)">
                          <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                      </mat-form-field>
                    </div>
                </div>
                <div class = "d-flex gap-5 m-0">
                  <div>                        
                    <mat-checkbox id="dailyActivitySend" class="example-margin body-font-size"  formControlName = 'DAILY_ACTIVITY_SEND'>Enable daily activity mail</mat-checkbox>
                  </div>
                  <div>
                    <mat-checkbox id="notifyGuestUser" class="example-margin body-font-size"  formControlName = 'NOTIFY_GUEST_MAIL'>Notify guest user mail</mat-checkbox>
                  </div>
                  <div>                            
                    <mat-checkbox id="guestUserInviteSch" class="example-margin body-font-size"  formControlName = 'GUEST_INVITE_SCH'>Enable guest user invitation link</mat-checkbox>
                  </div>
                    <!-- <div class="col-md-6">
                        <div>                        
                          <mat-checkbox id="dailyActivitySend" class="example-margin body-font-size"  formControlName = 'DAILY_ACTIVITY_SEND'>Enable daily activity mail</mat-checkbox>
                        </div>
                        <div>
                          <mat-checkbox id="notifyGuestUser" class="example-margin body-font-size"  formControlName = 'NOTIFY_GUEST_MAIL'>Notify guest user mail</mat-checkbox>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div>                            
                          <mat-checkbox id="guestUserInviteSch" class="example-margin body-font-size"  formControlName = 'GUEST_INVITE_SCH'>Enable guest user invitation link</mat-checkbox>
                        </div>
                    </div> -->
                </div>
                <div class="d-flex row justify-content-end pd-r-23">
                  
                      <button mat-raised-button color = "primary" class="save-custom" (click)="saveEmailSettings()">SAVE</button>
                  
                      <button mat-raised-button color = "primary" class="reset-custom" (click) = "resetDefaultVal()">RESET</button>
                  
                </div>
              </form>
          </div>
        </cdk-accordion-item>
        <cdk-accordion-item
          #accordionItemTwo ="cdkAccordionItem"
          class="example-accordion-item acc-separator"
          role="button"
          tabindex="1"
          [attr.id]="'accordion-header-' + 2"
          [attr.aria-expanded]="accordionItemTwo.expanded"
          [attr.aria-controls]="'accordion-body-' + 2">
          <div class="example-accordion-item-header acc-header-btm-brdr acc-header-lft-brder" (click)="accordionItemTwo.toggle()">
            <h3 class="margin-0">Notes Settings</h3>
            <span class="example-accordion-item-description">
              <mat-icon class="cmmn-icn-color" (click) = "resetDefaultVal()">{{ accordionItemTwo.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
            </span>
          </div>
          <div
            class="example-accordion-item-body"
            role="region"
            [style.display]="accordionItemTwo.expanded ? '' : 'none'"
            [attr.id]="'accordion-body-' + 2"
            [attr.aria-labelledby]="'accordion-header-' + 2">
              <form [formGroup]= 'notesSettingsValues'>
                <div class="d-flex gap-5">
                  <div class="">
                    <mat-checkbox id="momEdit" class="example-margin body-font-size"  formControlName = 'MOMEDIT' >Enable edit rights to all participants</mat-checkbox>
                  </div>
                  <div class="">
                    <mat-checkbox id="showTz" class="example-margin body-font-size" formControlName = 'SHOWTZ_AI'  >Show timezone along with date</mat-checkbox>
                  </div>
                </div>
                <!-- <div class="d-flex row pd-r-23">
                  <div class = "col-md-6 m-0">
                    <div class="m-l-10">
                      <mat-checkbox id="momEdit" class="example-margin body-font-size"  formControlName = 'MOMEDIT' >Enable edit rights to all participants</mat-checkbox>
                    </div>
                  </div>
                  <div class = "col-md-6">
                    <div class="m-l-10">
                      <mat-checkbox id="showTz" class="example-margin body-font-size" formControlName = 'SHOWTZ_AI'  >Show timezone along with date</mat-checkbox>
                    </div>
                  </div>
                </div> -->
                <div class="d-flex row justify-content-end pd-r-23">
                  <button mat-raised-button color = "primary" class="save-custom" (click) = "saveNoteSettings()">SAVE</button>
                  <button mat-raised-button color = "primary" class="reset-custom" (click) = "resetDefaultVal()">RESET</button>
                </div>
              </form>
          </div>
        </cdk-accordion-item>
        <cdk-accordion-item
        #accordionItemThree ="cdkAccordionItem"
        class="example-accordion-item acc-separator"
        role="button"
        tabindex="2"
        [attr.id]="'accordion-header-' + 3"
        [attr.aria-expanded]="accordionItemThree.expanded"
        [attr.aria-controls]="'accordion-body-' + 3">
        <div class="example-accordion-item-header acc-header-btm-brdr acc-header-lft-brder" (click)="accordionItemThree.toggle()">
          <h3 class="margin-0">Dashboard Settings</h3>
          <span class="example-accordion-item-description">
            <mat-icon class="cmmn-icn-color" (click) = "resetDefaultVal()">{{ accordionItemThree.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
            <!-- Click to  -->
          </span>
        </div>
        <div
          class="example-accordion-item-body"
          role="region"
          [style.display]="accordionItemThree.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + 3"
          [attr.aria-labelledby]="'accordion-header-' + 3">
            <form [formGroup]= 'dashboardSettings'>
              <div class="d-flex row pd-r-23">
                <div class = "col-md-6">
                  <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                      <mat-label class="body-font-size">Upcoming meeting to be displayed (in days)</mat-label>
                      <input matInput type="text" formControlName = 'UPCOMING_MEETING_CONF' maxlength = '3' (keypress)="numberOnly($event)">
                      <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                  </mat-form-field>
                </div>
                <div class = "col-md-6">
                  <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                      <mat-label class="body-font-size">Past meetings to be displayed (in days)</mat-label>
                      <input matInput type="text" formControlName = 'PAST_MEETING_CONF' maxlength = '3' (keypress)="numberOnly($event)">
                      <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                  </mat-form-field>
                </div>
              </div>
              <div class="d-flex row pd-r-23">
                <div class = "col-md-6">
                  <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                      <mat-label class="body-font-size">Task to be displayed (in days)</mat-label>
                      <input matInput type="text" formControlName = 'UPCOMING_TASK_CONF' maxlength = '3' (keypress)="numberOnly($event)">
                      <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                  </mat-form-field>
                </div>
                <div class = "col-md-6">
                  <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                      <mat-label class="body-font-size">Move meetings from upcoming to past in XX minutes after planned end time</mat-label>
                      <input matInput type="text" formControlName = 'UPCOMING_MEETING_WAIT_CONF' maxlength = '3' (keypress)="numberOnly($event)">
                      <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                  </mat-form-field>
                </div>
              </div>
              <div class="d-flex row pd-r-23">
                <div class = "col-md-6">
                  <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                      <mat-label class="body-font-size">Display start/join button XX minutes before schedule start</mat-label>
                      <input matInput type="text" formControlName = 'UPCOMING_START_CONF' maxlength = '3' (keypress)="numberOnly($event)">
                      <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                  </mat-form-field>
                </div>
                <div class = "col-md-6">
                  <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                      <mat-label class="body-font-size">Delete meetings XX days from meeting created date</mat-label>
                      <input matInput type="text" formControlName = 'DELETE_MEET_CONF' maxlength = '3' (keypress)="numberOnly($event)">
                      <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                  </mat-form-field>
                </div>
              </div>
              <div class="d-flex row justify-content-end pd-r-23">
                <button mat-raised-button color = "primary" class="save-custom" (click)= "saveDashboardSettings()">SAVE</button>
                <button mat-raised-button color = "primary" class="reset-custom" (click) = "resetDefaultVal()">RESET</button>
              </div>
            </form>
        </div>
        </cdk-accordion-item>
        <cdk-accordion-item
        #accordionItemFour ="cdkAccordionItem"
        class="example-accordion-item acc-separator"
        role="button"
        tabindex="3"
        [attr.id]="'accordion-header-' + 4"
        [attr.aria-expanded]="accordionItemFour.expanded"
        [attr.aria-controls]="'accordion-body-' + 4">
        <div class="example-accordion-item-header acc-header-btm-brdr acc-header-lft-brder" (click)="accordionItemFour.toggle()">
          <h3 class="margin-0">Others</h3>
          <span class="example-accordion-item-description">
            <mat-icon class="cmmn-icn-color" (click) = "resetDefaultVal()">{{ accordionItemFour.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
          </span>
        </div>
        <div
          class="example-accordion-item-body"
          role="region"
          [style.display]="accordionItemFour.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + 4"
          [attr.aria-labelledby]="'accordion-header-' + 4">
          <form [formGroup]= 'otherSettingValues'>
            <div class="d-flex row pd-r-23">
              <div class = "col-md-6">
                <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                    <mat-label class="body-font-size">Alert XX minutes before agenda time</mat-label>
                    <input matInput type="text" formControlName = 'ALL_NOTIFIC_COUNT' maxlength = '3' (keypress)="numberOnly($event)">
                    <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                </mat-form-field>
              </div>
              <div class = "col-md-6">
                <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                    <mat-label class="body-font-size">Number of alerts in the notification</mat-label>
                    <input matInput type="text" formControlName = 'TIMER_EXTEND_DURATION' maxlength = '3' (keypress)="numberOnly($event)">
                    <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                </mat-form-field>
              </div>
            </div>
            <div class="d-flex row pd-r-23">
              <div class = "col-md-6">
                <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                    <mat-label class="body-font-size">Enable new MoM creation after XX hours of meeting ends</mat-label>
                    <input matInput type="text" formControlName = 'WAIT_TO_CREATE_MOM' maxlength = '3' (keypress)="numberOnly($event)">
                    <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                </mat-form-field>
              </div>
              <div class = "col-md-6">
                
              </div>
            </div>
            
            <div class="d-flex row justify-content-end pd-r-23">
              <button mat-raised-button color = "primary" class="save-custom" (click) = "saveOtherSettings()">SAVE</button>
              <button mat-raised-button color = "primary" class="reset-custom" (click) = "resetDefaultVal()">RESET</button>
            </div>
          </form>
        </div>
        </cdk-accordion-item>
        
    <cdk-accordion-item
        #accordionItemFive ="cdkAccordionItem"
        class="example-accordion-item acc-separator"
        role="button"
        tabindex="3"
        [attr.id]="'accordion-header-' + 5"
        [attr.aria-expanded]="accordionItemFive.expanded"
        [attr.aria-controls]="'accordion-body-' + 5">
        <div class="example-accordion-item-header acc-header-btm-brdr acc-header-lft-brder" (click)="accordionItemFive.toggle()">
          <h3 class="margin-0">Microsoft Outlook Calendar</h3>
          <span class="example-accordion-item-description">
            <mat-icon class="cmmn-icn-color" (click) = "resetDefaultVal()">{{ accordionItemFive.expanded ? 'close' : 'add_circle_outline' }}</mat-icon>
          </span>
        </div>
        <div
          class="example-accordion-item-body"
          role="region"
          [style.display]="accordionItemFive.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + 5"
          [attr.aria-labelledby]="'accordion-header-' + 5">
          <form [formGroup]= 'outlookCal'>
            <div class="d-flex row pd-r-23">
              <div class = "col-md-6">
                <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                    <mat-label class="body-font-size">Application(client)Id</mat-label>
                    <input matInput type="text" formControlName = 'APP_ID_CONF' maxlength = '3' (keypress)="numberOnly($event)">
                    <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                </mat-form-field>
              </div>
              <div class = "col-md-6">
                <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                    <mat-label class="body-font-size">Client Secret</mat-label>
                    <input matInput type="text" formControlName = 'CLIENT_SECRET_CONF' maxlength = '3' (keypress)="numberOnly($event)">
                    <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                </mat-form-field>
              </div>
            </div>
            <div class="d-flex row pd-r-23">
              <div class = "col-md-6">
                <mat-form-field  class="m-2 example-full-width" [ngStyle]="{'width':'100%'}">
                    <mat-label class="body-font-size">Directory(Tenant)Id</mat-label>
                    <input matInput type="text" formControlName = 'DIRECTORY_ID_CONF' maxlength = '3' (keypress)="numberOnly($event)">
                    <!-- <mat-error *ngIf="checkError('userName', 'required')">*User Name is required</mat-error> -->
                </mat-form-field>
              </div>
              <div class = "col-md-6">
                
              </div>
            </div>
            
            <div class="d-flex row justify-content-end pd-r-23">
              <button mat-raised-button color = "primary" class="save-custom" (click) = "outlookCalSave()">SAVE</button>
              <button mat-raised-button color = "primary" class="reset-custom" (click) = "resetDefaultVal()">RESET</button>
            </div>
          </form>
        </div>
        </cdk-accordion-item>

    </cdk-accordion>
  </div>
  <div *ngIf="userId==154">
    <input type="text" placeholder="PreMeetingId" [(ngModel)]="preMeetId"/><br>
    <input type="text" placeholder="CurMeetingId" [(ngModel)]="curMeetId"/><br>
    <button (click)="followup()">change</button>
  </div>
</div>
